/* eslint-disable react-hooks/exhaustive-deps */
import { useRef, useState } from "react"
import { CURVE_TYPE, ICurveDot, ILandingPrimitive, IScreenPosition, SPEECH_NOSE_HEIGHT } from "src/modules/pe-landing-module/data/interfaces"
import Curve from "./Curve"


/* Protopia Ecosystem component */
export interface ISpeechBubbleProps {
   primitive: ILandingPrimitive 
   children: JSX.Element
}
const SpeechBubble  = (props: ISpeechBubbleProps): JSX.Element => {
    const ref = useRef(null)
    const primitive = (props.primitive)
    const data:any  = ( primitive.data || {})  
    const position: IScreenPosition = primitive.position 
    
    const left = 0
    const top = 0
    const color = "var(--force-contast-color)" 
    const fill = primitive.background || "transparent"
    const strokeW = primitive.strokeWidth || 4
    const strokeW1 = strokeW - 1
    const nose = SPEECH_NOSE_HEIGHT

    const [height, setHeight] = useState<number>( Number( position.height ) ) 

    const path: ICurveDot[] = [
        { 
            type: CURVE_TYPE.M, 
            x: 0,
            y: strokeW * 1.5,
            left:true,
            top: true,
        },
        { 
            type: CURVE_TYPE.L, 
            x: Number( position.width ),
            y: strokeW * 1.5,
            left:true,
            top: true,
        },
        { 
            type: CURVE_TYPE.M, 
            x: 0,
            y:  height - nose,
            left:true,
            top: true,
        },
        { 
            type: CURVE_TYPE.L, 
            x: 100,
            y:  height - nose,
            left:true,
            top: true,
        },
        { 
            type: CURVE_TYPE.L, 
            x: 100,
            y: height,
            left:true,
            top: true,
        },
        { 
            type: CURVE_TYPE.L, 
            x: 100 + nose,
            y: height - nose,
            left: true,
            top: true,
        },
        { 
            type: CURVE_TYPE.L, 
            x: Number( position.width ),
            y: height - nose,
            left: true,
            top: true,
        },
    ],
    pathFill: ICurveDot[] = [
        { 
            type: CURVE_TYPE.M, 
            x: Number( position.width ) - strokeW1,
            y: strokeW * 1.5 - strokeW1,
            left:true,
            top: true,
        },
        { 
            type: CURVE_TYPE.L, 
            x: 0 - strokeW1,
            y: strokeW * 1.5 - strokeW1,
            left:true,
            top: true,
        },
        { 
            type: CURVE_TYPE.L, 
            x: 0 - strokeW1,
            y:  height - nose - strokeW1,
            left:true,
            top: true,
        },
        { 
            type: CURVE_TYPE.L, 
            x: 100 - strokeW1,
            y:  height - nose - strokeW1,
            left:true,
            top: true,
        },
        { 
            type: CURVE_TYPE.L, 
            x: 100 - strokeW1,
            y: height - strokeW1,
            left:true,
            top: true,
        },
        { 
            type: CURVE_TYPE.L, 
            x: 100 + nose - strokeW1,
            y: height - nose - strokeW1,
            left: true,
            top: true,
        },
        { 
            type: CURVE_TYPE.L, 
            x: Number( position.width ) - strokeW1,
            y: height - nose - strokeW1,
            left: true,
            top: true,
        },
    ],
    width = Number( position.width )
    
    // console.log(primitive.position.width, position.width)
    
    return <div className='pe-speech-bubble-container' data-primitive-type={primitive["data-primitive-type"]}>
        <div className={`speech-bubble ${data.className} speech-bubble-minimal-${primitive.id} medallion-padder`} style={data.style} ref={ref}>
            <div className={`speech-bubble-content-0`}> 
                { props.children }
                {/*  */}
            </div>
        </div> 
        <Curve
            primitive={{  
                id : data.id + "-fill",
                position: {
                    left,
                    top,
                    width,
                    height,
                },
                bg: "transparent" ,
                fill,//"transparent",
                path: pathFill,
                className: "untouchble position-absolute z-index--1 top left"
            } as any}
        />
        <Curve
            primitive={{  
                id : data.id,
                position: {
                    left,
                    top,
                    width,
                    height,
                },
                bg: "transparent" ,
                fill: "transparent",
                color,
                strokeW,           
                path,
                className: "untouchble position-absolute z-index-3 top left"
            } as any}
        />
    </div>
}
export default SpeechBubble 